import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { BeatsSortBy } from '../../../enums/enums'
import { AppService } from '../../../services/prod/app.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { SetColorsService } from '../../../services/set-colors.service'

@Component({
  selector: 'bmcore-tracks-page',
  templateUrl: './bmcore-tracks-page.component.html',
  styleUrls: ['./bmcore-tracks-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTracksPageComponent implements OnInit {
  lg: LgType
  colorSettingsMode = false

  beatmakerId: number
  currentSortById: BeatsSortBy = BeatsSortBy.Date

  constructor(
    private i18nService: I18nService,
    private setColorsService: SetColorsService,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.getColorSettingsMode()

    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res?.beatmakerId) {
        this.beatmakerId = res.beatmakerId
        this.currentSortById = res.defaultBeatsSorting
      }
    })
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
